import React from 'react';
import { Cookie } from 'lucide-react';
import Header from '@/components/layout/Header';
import FooterNew from '@/components/layout/FooterNew';

const CookiesPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-1">
        <section className="bg-gradient-to-br from-red-50 to-cyan-50 py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <Cookie className="w-12 h-12 text-red-600 mx-auto mb-4" />
              <h1 className="text-4xl font-bold gradient-text mb-4">
                Politique des cookies
              </h1>
              <p className="text-gray-600">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto prose prose-lg">
              <h2>1. Qu'est-ce qu'un cookie ?</h2>
              <p>
                Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, smartphone, tablette) 
                lorsque vous visitez un site web. Les cookies permettent au site de mémoriser vos actions et 
                préférences pendant une période donnée.
              </p>

              <h2>2. Types de cookies utilisés</h2>
              
              <h3>2.1 Cookies strictement nécessaires</h3>
              <p>
                Ces cookies sont essentiels au fonctionnement de la plateforme. Ils permettent :
              </p>
              <ul>
                <li>L'authentification et la gestion de session</li>
                <li>La sécurisation des transactions</li>
                <li>La mémorisation de vos préférences de langue</li>
              </ul>
              <p className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
                <strong>Note :</strong> Ces cookies ne peuvent pas être désactivés car ils sont indispensables 
                au fonctionnement du site.
              </p>

              <h3>2.2 Cookies de performance</h3>
              <p>
                Ces cookies nous aident à comprendre comment les visiteurs utilisent notre site :
              </p>
              <ul>
                <li>Pages visitées</li>
                <li>Temps passé sur chaque page</li>
                <li>Messages d'erreur rencontrés</li>
              </ul>
              <p>Les données collectées sont anonymes et utilisées uniquement pour améliorer nos services.</p>

              <h3>2.3 Cookies de fonctionnalité</h3>
              <p>
                Ces cookies permettent d'améliorer votre expérience en mémorisant :
              </p>
              <ul>
                <li>Vos préférences (langue, devise)</li>
                <li>Vos paramètres d'affichage</li>
                <li>Vos dernières recherches</li>
              </ul>

              <h3>2.4 Cookies tiers</h3>
              <p>
                Nous utilisons des services tiers qui peuvent déposer leurs propres cookies :
              </p>
              <ul>
                <li><strong>Google Maps :</strong> Pour la géolocalisation et le calcul d'itinéraires</li>
                <li><strong>Stripe :</strong> Pour le traitement sécurisé des paiements</li>
              </ul>

              <h2>3. Durée de conservation</h2>
              <p>La durée de vie des cookies varie selon leur type :</p>
              <ul>
                <li><strong>Cookies de session :</strong> Supprimés à la fermeture du navigateur</li>
                <li><strong>Cookies persistants :</strong> Conservés jusqu'à leur expiration (maximum 12 mois)</li>
              </ul>

              <h2>4. Gestion des cookies</h2>
              
              <h3>4.1 Paramétrage du navigateur</h3>
              <p>
                Vous pouvez configurer votre navigateur pour refuser ou supprimer les cookies :
              </p>
              <ul>
                <li><strong>Chrome :</strong> Paramètres &gt; Confidentialité et sécurité &gt; Cookies</li>
                <li><strong>Firefox :</strong> Options &gt; Vie privée et sécurité &gt; Cookies</li>
                <li><strong>Safari :</strong> Préférences &gt; Confidentialité &gt; Cookies</li>
                <li><strong>Edge :</strong> Paramètres &gt; Confidentialité &gt; Cookies</li>
              </ul>

              <h3>4.2 Panneau de contrôle Coli Noki</h3>
              <p>
                Vous pouvez gérer vos préférences de cookies directement depuis notre 
                <a href="/legal/privacy-settings" className="text-red-600 hover:underline"> Panneau de paramètres</a>.
              </p>

              <h2>5. Conséquences de la désactivation</h2>
              <p>
                La désactivation de certains cookies peut affecter votre expérience :
              </p>
              <ul>
                <li>Impossibilité de rester connecté</li>
                <li>Perte de vos préférences</li>
                <li>Fonctionnalités limitées</li>
              </ul>

              <h2>6. Cookies et données personnelles</h2>
              <p>
                Certains cookies peuvent contenir des données personnelles (identifiant de session). 
                Ces données sont traitées conformément à notre 
                <a href="/privacy" className="text-red-600 hover:underline"> Politique de confidentialité</a>.
              </p>

              <h2>7. Mise à jour de la politique</h2>
              <p>
                Nous pouvons mettre à jour cette politique pour refléter les changements dans nos pratiques. 
                La date de dernière mise à jour est indiquée en haut de cette page.
              </p>

              <h2>8. Contact</h2>
              <p>
                Pour toute question concernant notre utilisation des cookies :
              </p>
              <ul>
                <li>Email : privacy@colinoki.com</li>
                <li>Téléphone : +242 05 087 12 50</li>
              </ul>
            </div>
          </div>
        </section>
      </main>

      <FooterNew />
    </div>
  );
};

export default CookiesPage;
